import { Card } from "@insights/ui";
import { Workflow } from "lucide-react";

export function EmptyState({ title, text }: { title: string; text: string }) {
  return (
    <Card className="empty">
      <Workflow />
      <h2>{title}</h2>
      <p>{text}</p>
    </Card>
  );
}
